import { appConfig } from '@/config/app-config';
import { setConsent } from '@/config/consent';
import type { Translator } from '@/i18n';

interface Props {
  t: Translator['t'];
  onAnswered: () => void;
}

/**
 * Запит згоди на статистику й cookie (GDPR). Неблокувальний: стартовий екран
 * під ним лишається робочим. Дві дії однакового вигляду — відмова мусить бути
 * такою ж легкою, як згода.
 */
export function ConsentBanner({ t, onAnswered }: Props): React.JSX.Element {
  const answer = (granted: boolean): void => {
    setConsent(granted ? 'granted' : 'denied');
    onAnswered();
  };

  return (
    <section className="consent" role="region" aria-label={t('privacySettingsLink')}>
      <p className="consent__text">{t('consentBannerText')}</p>
      <a className="consent__policy" href={appConfig.privacyPolicyUrl} target="_blank" rel="noreferrer">
        {t('privacyPolicy')}
      </a>
      <div className="consent__actions">
        <button
          type="button"
          className="button consent__button"
          data-testid="consent-deny"
          onClick={() => {
            answer(false);
          }}
        >
          {t('consentDeny')}
        </button>
        <button
          type="button"
          className="button consent__button"
          data-testid="consent-allow"
          onClick={() => {
            answer(true);
          }}
        >
          {t('consentAllow')}
        </button>
      </div>
    </section>
  );
}
